var id = 0;

export default class IMesh
{
    constructor()
    { this.#id = id++; }

// Public // -----------------------------------------------------------------------------------------------------------
    GetId()
    { return this.#id; }

// ---------------------------------------------------------------------------------------------------------------------
    GetVertices()
    {  throw new Error("GetVertices() isn't implemented"); }

// ---------------------------------------------------------------------------------------------------------------------
    GetFaces()
    {  throw new Error("GetFaces() isn't implemented"); }

// ---------------------------------------------------------------------------------------------------------------------
    GetNormals()
    {  throw new Error("GetNormals() isn't implemented"); }

// ---------------------------------------------------------------------------------------------------------------------
    GetVerticesAmount()
    { return this.GetVertices().length / 3; }

// ---------------------------------------------------------------------------------------------------------------------
    GetIndexAmount()
    { return this.GetFaces().length; }

// ---------------------------------------------------------------------------------------------------------------------
    GetGPUVertexBuffer()
    { return this.#gpuVertexBuffer; }

// ---------------------------------------------------------------------------------------------------------------------
    GetGPUNormalBuffer()
    { return this.#gpuNormalBuffer; }

// ---------------------------------------------------------------------------------------------------------------------
    GetGPUIndexBuffer()
    { return this.#gpuIndexBuffer; }

// ---------------------------------------------------------------------------------------------------------------------
    SetGPUVertexBuffer(gpuBuffer)
    { this.#gpuVertexBuffer = gpuBuffer; }

// ---------------------------------------------------------------------------------------------------------------------
    SetGPUNormalBuffer(gpuBuffer)
    { this.#gpuNormalBuffer = gpuBuffer; }

// ---------------------------------------------------------------------------------------------------------------------
    SetGPUIndexBuffer(gpuBuffer)
    { this.#gpuIndexBuffer = gpuBuffer; }

// Private // ----------------------------------------------------------------------------------------------------------
    #gpuVertexBuffer;
    #gpuIndexBuffer;
    #gpuNormalBuffer;

    #id;
};
